//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as adminActions } from 'store/modules/admin';

// === API ===
import { prokeyApi } from 'api/prokey';
import { onRoles, removeRole, removeListener, onModules, requestModules, requestRoles} from 'api/prokey/prokey.websocket';
// === COMPONENTS ===
import { useTheme } from '@mui/material/styles';
import { AddRoleDialog } from './AddRoleDialog/AddRoleDialog';
import { RoleRow } from './RoleRow';

// === STYLES ===
import {
  Box,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';


//#endregion

//-----------------------------------------------------------------
export function RolesPanel() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const [ roles   , setRoles   ] = useState( [] );
  const [ modules , setModules ] = useState( [] );

  const [ showAddRoleModal , setShowAddRoleModal ] = useState( false );

  //#endregion

  //#region [EVENTS]

  //#endregion

  //#region [EFFECT]

  useEffect(() => {
    //-----------------------------------------------------------------
    function handleRoles( data ){
      //-----------------------------------------------------------------
      setRoles( data );
    }
    //-----------------------------------------------------------------
    function handleModules( data ){
      //-----------------------------------------------------------------
      setModules( data.modules );
    }

    onRoles  ( handleRoles   );
    onModules( handleModules );

    requestRoles  ();
    requestModules();

    return () => {
      removeListener( 'ROLES'   , handleRoles   );
      removeListener( 'MODULES' , handleModules );
    }
  }, []);

  //#endregion

  //#region [ACCESS]

  //#endregion
 
  //#region [MODIFY]
  
  //-----------------------------------------------------------------
  function removeRoles(roleId) {
    //-----------------------------------------------------------------
    removeRole([roleId]);
  };

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function getRoleSortVal( role ) {
    //-----------------------------------------------------------------
         if ( role.RoleName === 'default'   ) return '1';
    else if ( role.RoleName === 'submitter' ) return '2';
    else if ( role.RoleName === 'manager'   ) return '3';
    else if ( role.RoleName === 'reporter'  ) return '4';
    else if ( role.RoleName === 'admin'     ) return '5';
    else if ( role.RoleName === 'keyer'     ) return '6';
    else return role.RoleName;
  }

  // ------------------------------------------------------
  // HEADERS

  //-----------------------------------------------------------------
  function displayHeaders() {
    //-----------------------------------------------------------------
    return (
      <TableHead>
        <TableRow>
          <TableCell>{           }</TableCell>
          <TableCell>{ 'Roles'   }</TableCell>
          <TableCell>{ 'Modules' }</TableCell>
        </TableRow>
      </TableHead>
    );
  }

  // ------------------------------------------------------
  // ROLE ROWS

  //-----------------------------------------------------------------
  function displayStaticRoleRows() {
    //-----------------------------------------------------------------
    let role_rows = [];

    const sorted_roles = roles.sort((a, b) => {
      return getRoleSortVal(a) < getRoleSortVal(b) ? -1 : 1;
    });
    for (const role of sorted_roles) {
      role_rows.push(
        <RoleRow
          key={role.id}
          role={role}
          modules={modules}
          removeRole={removeRoles}
        />
      );
    }
    return <TableBody>{role_rows}</TableBody>;
  }

  // ------------------------------------------------------
  // DISPLAY

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={{
        width: '100%',
        margin: theme.spacing(0),
      }}>
        <AddRoleDialog
          showDialog={showAddRoleModal}
          setShowDialog={setShowAddRoleModal}
         // refreshRoles={refreshRoles}
        />
        <Box sx={{
    display: 'flex',
    width: '100%',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
  }}>
          <Button
            sx={{
              margin: theme.spacing(1),
              marginLeft: 'auto',
              backgroundColor: theme.palette.success.light,
              '&:hover': {
                backgroundColor: theme.palette.success.main,
              },
            }}
            variant='contained'
            startIcon={<AddCircleIcon />}
            onClick={() => setShowAddRoleModal(true)}
            name='add_role_btn'
          >
            Add Role
          </Button>
        </Box>
        <Table size='small' sx={{
    width: '100%',
  }}>
          {displayHeaders()}
          {displayStaticRoleRows()}
        </Table>
      </Box>
    );
  }

  //#endregion

  return display();
}
